import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layouts/snippet-layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p className="t-lead">LearnUXD brings you this course on how to take the next steps to quickly but effectively build out web pages and components with advanced CSS technique and an eye for usability and accessibility.</p>
    <p>{`By the end of this course students will be able to:`}</p>
    <ul>
      <li parentName="ul">{`Communicate professionally using knowledge of web design terms.`}</li>
      <li parentName="ul">{`Work fluently with modern technologies and best practices to develop and enhance web pages for usability, searchability and accessibility.`}</li>
      <li parentName="ul">{`Locate and use various resources to further develop knowledge and skills for web design.`}</li>
      <li parentName="ul">{`Apply grid design, web aesthetics and appropriate style to develop advanced, visually appealing, and usable web pages, web sites, and content navigation in a variety of genres.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      